import { ApiProvider } from '@src/context/Api';
import { RoutesProvider } from '@src/context/Routes/Routes';
import { UserProvider } from '@src/features/Users/context';
import { VisibilityProvider } from '@src/features/Users/context/Visibility';
import { PrintProvider } from '@uhg-abyss/web/ui/PrintProvider';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * ApplicationProvider
 *
 * Handles setting the context to be used globally throughout the application.
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function ApplicationProvider(props) {
  const { children } = props;

  return (
    <ApiProvider>
      <RoutesProvider>
        <PrintProvider>
          <UserProvider>
            <VisibilityProvider>{children}</VisibilityProvider>
          </UserProvider>
        </PrintProvider>
      </RoutesProvider>
    </ApiProvider>
  );
}

ApplicationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
